import React from 'react';

const Sectionbreak = ({ 
  title = 'Featured', 
  highlight = 'Projects', 
  description = 'Explore some of our completed and ongoing developments that blend design, innovation, and impact.' 
}) => {
  return (
    <div className="text-center mb-16">
      <h2 className="text-xl md:text-2xl font-bold text-gray-600">
        {title} <span className="text-teal-600">{highlight}</span>
      </h2>
      <p className="mt-4 text-gray-500 text-lg max-w-2xl font-light mx-auto">
        {description}
      </p>
    </div>
  );
};

export default Sectionbreak;
